import * as R from 'ramda'

import { ACTION_EDIT } from './model'

export const getActions = (state, handlers) => {
  const { actions, template } = state
  const { onEdit } = handlers

  return R.map(action => {
    const mapTypeToOnClick = {
      [ACTION_EDIT]: () => onEdit({ template }),
    }

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
    }
  }, actions)
}
